module.exports = __webpack_public_path__ + "img/food-sensitivity-journal_B09MZXWQP6.8efa781e.jpg";